import { render, staticRenderFns } from "./board-list.vue?vue&type=template&id=0eb8b08f"
import script from "./board-list.vue?vue&type=script&lang=js"
export * from "./board-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports